import React, { useState } from 'react';

import { Check, CopyIcon, ExternalLink, UnplugIcon } from 'lucide-react';
import { useAccount, useDisconnect } from 'wagmi';

import ChainIcon from '@/components/ChainIcon';
import { Button } from '@/components/shadcn/ui/button';
import { Collapsible, CollapsibleTrigger } from '@/components/shadcn/ui/collapsible';
import { cn, truncateMidAddressInputValue } from '@/utils';

const HeaderWalletDrawerEvmWalletDetails: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const { disconnect } = useDisconnect();
  const { address: account, chain } = useAccount();

  const handleCopyAddress = (e: React.MouseEvent) => {
    e.stopPropagation();
    void navigator.clipboard.writeText(account || '');
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 300);
  };

  return (
    <Collapsible
      open={isExpanded}
      onOpenChange={setIsExpanded}
      className="bg-background/60 hover:bg-background/80 flex w-full flex-col justify-between gap-2 overflow-hidden
        rounded-xl p-2.5 text-sm text-gray-400 sm:px-2.5 md:px-4"
    >
      <CollapsibleTrigger className={cn('flex w-full cursor-pointer items-center justify-between gap-1')} asChild>
        <div className="flex w-full items-center justify-start text-left">
          <div className="bg-background relative mr-2 shrink-0 rounded-full p-1">
            <ChainIcon src={(chain?.custom?.icon as string) || ''} className="size-8" />
          </div>
          <div className="text-primary-foreground w-full overflow-hidden text-lg font-semibold">
            {truncateMidAddressInputValue((account || '')!, 16)}
          </div>
          <div className="flex gap-2">
            <Button
              variant="secondary"
              className="bg-foreground h-auto rounded-xl p-2 leading-2"
              onClick={handleCopyAddress}
            >
              {isCopied ? <Check className="size-4" color="green" /> : <CopyIcon className="size-4" />}
            </Button>

            <Button
              variant="secondary"
              className="bg-foreground h-auto rounded-xl p-2 leading-2"
              onClick={(e) => {
                e.stopPropagation();
                window.open(
                  `${chain?.blockExplorers?.default.url}/address/${account}`,
                  '_blank',
                  'noopener,noreferrer'
                );
              }}
            >
              <ExternalLink className="size-4" />
            </Button>

            <Button
              variant="secondary"
              className="bg-foreground h-auto rounded-xl p-2 leading-2"
              onClick={(e) => {
                e.stopPropagation();
                disconnect();
              }}
            >
              <UnplugIcon className="size-4" />
            </Button>
          </div>
        </div>
      </CollapsibleTrigger>

      {/* <div className="flex cursor-pointer justify-center" onClick={() => setIsExpanded(!isExpanded)}>
        <ChevronDown className={cn('size-4 transition-transform duration-200', { 'rotate-180': isExpanded })} />
      </div> */}
    </Collapsible>
  );
};

export default HeaderWalletDrawerEvmWalletDetails;
